const paintingItems = {
  _id: "painting",
  galleryItems: [
    {
      name: "Horses...",
      imgName: "miniature-horses.jpg",
      altText:
        "Someone adjusts the cinch on a miniature horse's saddle at the Wimberley Rodeo.",
      media: "Acrylic on board",
      width: "14",
      height: "11",
      sold: false,
      description:
        "<p>This scene was a sight at the Wimberley Rodeo: as a woman bent down to adjust the cinch on a miniature horse's saddle I couldn't help but see the humor in the visual and took a picture to paint it.</p>"
    },
    {
      name: "Mount Wilson",
      imgName: "mount-wilson.jpg",
      altText:
        "Mount Wilson as seen from the ski ranches in Telluride, Colorado.",
      media: "Oil on canvas",
      height: "12",
      width: "24",
      sold: false,
      description:
        "<p>This is Mount Wilson, a mountain range you may recognize from the Coors beer logo.  I sometimes visit friends in Telluride, Colorado and the stellar view of this part of the San Miguel mountains sweeps out from their back yards.</p>"
    },
    {
      name: "Colonel",
      imgName: "colonel.jpg",
      altText: "A Palomino named Colonel. Commissioned.",
      media: "Oil on Canvas",
      width: "24",
      height: "48",
      sold: true,
      description:
        "<p>A private resident in Telluride, Colorado commissioned four works from me, each of them a portrait of one of her horses (and a donkey).  They were painted in a tetraptych with the San Miguel mountains in the background to tie the works together.  This is one here is Colonel.</p>"
    },
    {
      name: "Scheutzen And Hackamore",
      imgName: "scheutzen-and-hackamore.jpg",
      altText:
        "A painting of a horse fitted with a hackamore and a rider carrying a Scheutzen rifle.",
      media: "Digital Painting",
      sold: false,
      description:
        "<p>This is a digital painting I created to submit to a role playing game franchise when I caught wind of their production of a Western-themed book line.</p>"
    },
    {
      name: "Gas Pump On Wilson Mesa",
      imgName: "gas-pump-on-wilson-mesa.jpg",
      altText: "A retro Conoco gas pump found up on Wilson Mesa in Colorado.",
      media: "Acrylic on canvas",
      width: "14",
      height: "11",
      sold: false,
      description:
        "<p>One overcast day up on the removed roads on Wilson Mesa in southwest Colorado, I came across a busted, rusted Conoco gas pump just standing on the roadside, smack in the big middle of nowhere. It was an abrupt, humorous visual to see this gas pump dropped off in the overgrowth and ranchland, so I had to stop and appreciate it.</p>"
    },
    {
      name: "Gas Pump On Wilson Mesa 2",
      imgName: "gas-pump-on-wilson-mesa-2.jpg",
      altText:
        "Another angle of a retro Conoco gas pump found up on Wilson Mesa in Colorado.",
      media: "Acrylic on canvas",
      width: "14",
      height: "11",
      sold: false,
      descriotion:
        "<p>This is the second painting of the gas pump I found out on the flats of Wilson Mesa, just sitting there in the big middle of absolutely nowhere to give the off traveler a kick and a laugh.</p>"
    },

    {
      name: "Runaway Ray",
      imgName: "ray.jpg",
      altText: "A chestnut stallion named Ray. Commissioned.",
      media: "Oil on Canvas",
      width: "24",
      height: "48",
      sold: true,
      description:
        "<p>A private resident in Telluride, Colorado commissioned four works from me, each of them a portrait of one of her horses (and a donkey).  They were painted in a tetraptych with the San Miguel mountains in the background to tie the works together.  This is one here is Ray, or Runaway Ray as he's called up on the Mesa.</p>"
    },

    {
      name: "The Gunnison From Pulpit Rock",
      imgName: "the-gunnison-from-pulpit-rock.jpg",
      altText:
        "The Gunnison From Pulpit Rock. A painting of the Gunnison river weaving through Black Canyon in Colorado.",
      media: "Acrylic on canvas",
      width: "48",
      height: "12",
      sold: false,
      description:
        "<p>The Black Canyon of the Gunnison National Park is full of scenic and terrifying, plummeting views with the Gunnison river gleaming in the sandstone like a thread of silver. This is the view from the Pulpit Rock overlook, painted on a 4 foot wide canvas.</p>"
    },
    {
      name: "Woody",
      imgName: "woody.jpg",
      altText: "A dapple cowpony named Woody. Commissioned.",
      media: "Oil on Canvas",
      width: "24",
      height: "48",
      sold: true,
      description:
        "<p>A private resident in Telluride, Colorado commissioned four works from me, each of them a portrait of one of her horses (and Scout, the donkey).  They were painted in a tetraptych with the San Miguel mountains in the background to tie the works together.<p><p>This is Woody, a boyish cowpony whose most lovable feature is the curl in his little ears.</p>"
    },

    {
      name: "Trellis At Trout Lake",
      imgName: "trout-lake.jpg",
      altText: "A railroad trellis at Trout Lake, Colorado.",
      media: "Acrylic on board",
      width: "13",
      height: "9.5",
      sold: false,
      description:
        "<p>The first time I went to Colorado it was to see a family friend in Telluride during the summer, and he took us on a tour of the places that made him fall in love with the place, including Trout Lake.</p><p>You really won't find a more bucolic place than among the aspen and blue spruce out in the mountains, and this vibrant acrylic painting serves to try and capture a snapshot of it.</p>"
    },
    {
      name: "Scout",
      imgName: "scout.jpg",
      altText: "A cute little burro. Commissioned.",
      media: "Oil on Canvas",
      width: "24",
      height: "48",
      sold: true,
      description:
        "<p>A private resident in Telluride, Colorado commissioned four works from me, each of them a portrait of one of her horses (and Scout, the donkey).  They were painted in a tetraptych with the San Miguel mountains in the background to tie the works together.<p><p>Originally, the project was for just the three horses, but Scout and his fluffy ears just couldn't be left out of their 'family' portrait, and so he joined the fold and turned the commission from a trio into a quartet.</p>"
    }
  ]
};

const digitalItems = {
  _id: 'digital',
  galleryItems: [{
    name: 'Sousanne',
    imgName: 'sousanne-signup.jpg',
    skills: ['html5', 'css3'],
    altText: 'The sign up screen for an in-progress budget mealplanning app.',
    description:
    "<p>Sousanne is a meal planning app aimed at low-income audiences.  It is intended for the browser and android thanks to how low-income audiences tend towards Android and in-browser apps.</p>"
  },
  {
    name: 'Ultimate Donations Landing Page,',
    imgName: 'ultimate-donations-landingpage-display.jpg',
    skills: ['html5', 'css3', 'copy writing', 'landing page design'],
    altText: 'The desktop version of a landing page for a donation directory service.',
    description:
    "<p>My redesign of UltimateDonations.org's landing page drove conversion rates up from their anemic numbers to a steady, weekly stream of new accounts.</p><p>The largest painpoint for organizations applying for donations is the time-consuming nature of the process, so I poured emphasis onto the time-saving value that UltimateDonations provides. Because securing conversions was a problem for UltimateDontions, I featured testimonials to cultivate trust and took care to tell the user that their account is 'free' to minimize a prospect's sense of risk.</p>"
  },
  {
    name: 'Ultimate Donations Landing Page, Mobile',
    imgName: 'ultimate-donations-landingpage-mobile.jpg',
    skills: ['html5' , 'css3' , 'responsive design', 'landing page design'],
    altText: 'The mobile version of a landing page for a donation directory service.',
    description: '<p>My responsive redesign of UltimateDonations.org as a whole, paired with strategically thought-out landing page copy, cut its bounce rate practically in half.  This is the version that received the most signups out of our A/B testing.</p>'
  },
  {
    name: 'Ultimate Donations Application Form',
    imgName: 'ultimate-donations-form.jpg',
    skills: ['html5' , 'css3' , 'UX design'],
    altText: "An example of the streamlined and simplified application form for Ultimate Donations.",
    description: "<p>I broke up UltimateDonations.org's extensive form field requirements into sections so that the user was never confronted with more than a handful of elements at a time.  I provided explanations why this information was needed to remind the user of what they stood to gain from filling out the form.</p><p>The simplicity and clarity this redesign provided led more users to complete the process and, most importantly, purchase a donor list at the end.</p>"
  },
  {
    name: 'Sousanne Recipe View',
    imgName: 'view-recipe.jpg',
    skills: ['Sketch'],
    altText: 'One of the mockups for the Sousanne app, showing a recipe view.',
    description: "<p>With Sousanne's focus on being a grocery shopping aid, I am designing a masculinized style sheet and a feminized stylesheet to explore which one will be more successful considering the contrasting gender demographics: While grocery shoppers in general are predominantly female, grocery shoppers who use list applications are predominantly male. This is the recipe view for the more feminine version of the design.</p>"
  }
  ]
}

const printItems = {
  _id: "print",
  galleryItems: [
    {
      name: "Test-Driven Development Book Cover",
      imgName: "testdrivendevelopment.jpg",
      altText: "A book cover for Test Driven Development by Tamaro Green.",
      description:
        "<p><b>Client:</b> Dr. Tamaro Green,  a software engineer and entrepreneur in Austin, Texas.</p><p>Test Driven Development is a book in an ongoing series.  Dr. Green needed a book cover that carried the same visual appeal of No Starch Press while maintaining its own, unique voice.</p><p>No Starch Press has an admirable brand with very joyful and nostalgic vibes and so when deciding what to do for Dr. Green I looked to the eclectic and eager look of art deco, which itself carries the power of nostalgia.  I went with smooth, minimalistic lines in order to stand out on the shelf, be that digital or physical, and while laboratory equipment would communicate the analytic nature of the book I still wanted to incorporate some immediately recognizable computer-related visuals, so I went with the background imagery of computer hardware like a motherboard or video card, and rendered it to suggest a UML diagram.</p>"
    },
    {
      name: "Big Data Analytics Book Cover",
      imgName: "bigdataanalytics.jpg",
      altText:
        "A book cover for Big Data Analytics: Frameworks by Tamaro Green.",
      description:
        "<p><b>Client:</b> Dr. Tamaro Green,  a software engineer and entrepreneur in Austin, Texas.</p><p>Big Data Analytics: Frameworks is a book in an ongoing series.  Dr. Green needed a book cover that carried the same visual appeal of No Starch Press while maintaining its own, unique voice.</p><p>The fetching contrasts and illustrative nature of No Starch Press book covers inspired my design as a springboard, and I used yellows as a nod to the palette that is so vital to the No Starch Press look, but beyond these conventions I wanted to stay unique to Dr. Green. I settled on a theme of laboratory instruments in order to go with the analytical nature of his work and subject matter, and I expanded the color pallete into greens and blues as a reflection of his personal name. I settled on a different type of 'exuberant' and 'nostalgic' vibe by going with an art-deco aesthetic instead of classic cartooning.</p>"
    },
    {
      name: "Baton Rouge Pride Fest 2015",
      imgName: "brpride2015.png",
      altText: "A red Baton Rouge Pride Fest poster for 2015.",
      description:
        "<p><b>Client:</b> Baton Rouge Pride, designing through FairGround Creative.</p><p>Baton Rouge Pride organizes a Pride Fest every year and in 2015 they needed a versatile advertisement that woud leap off the wall against the visual competition of the city, all while packing the information that their sponsors required without losing the message to visual clutter.</p><p>I wanted to lead the eye inevitably to 'live music and entertainment' to communicate why people should go, so I invested in a lot of contrast on the phrase, and placed that part of the copy so that the visual flow would lead from it, towards the details of when and where.  I provided this advertisement in various colors, each with the same layout and typesetting but a different palette, because I was designing posters that would be put on an unpredictable range of places, potentially competing against packed community or club bulletin boards and streetlight posts and so on.  With multicolored versions from the pride flag referenced in their logo, their advertisements could reflect the flag but also stand out against whatever other posters they may be competing with when they were distributed across the city.</p>"
    },
    {
      name: "We Stop Deer Business Card",
      imgName: "westopdeercard.jpg",
      altText: "The front of a business card for We Stop Deer.",
      description:
        "<p><b>Client:</b> WeStopDeer is a company selling a pest control product under the same, apt name.</p><p>WeStopDeer, which used direct mail campaigns to advertise, was struggling to establish a customer base and their existing marketing collateral left them stranded with anemic response rates due to its unfocused message.  After consulting with their sales manager about the types of people they tried to market to, landscaping companies stood out among their desired clientele as a promising lead.  After researching the concerns and needs of landscapers and lawncare contractors, I capitalized on the seasonal nature of their businesses (many landscapers rely on a harsh winter to drum up calls from homeowners in need of repairs from the frost and snow and struggle to offer value to homeowners through the spring and summer). My marketing collateral, targeted at landscaping professionals, positioned WeStopDeer as a profitable tool to quickly expand their services outside of its seasonal confines and quadrupled WeStopDeer's response rates in direct mail campaigns.</p>"
    }
  ]
};
const logoItems = {
  _id: "logos",
  galleryItems: [
    {
      name: "Archery For Kids Logo",
      imgName: "archeryforkids-logo.png",
      altText:
        "Logo for Archery For Kids, a small central-Texas business that tutors children in archery.",
      description:
        "<p><b>Client:</b> Archery For Kids, Canyon Lake, Texas.  Archery For Kids brings archery lessons and the range to children.</p><p>Archery For Kids advertised largely through cut vinyl roadside signage and car vinyl, but was meeting some challenges with their old, illustrative logo being too difficult to reproduce and too prone to partial fading in the central Texas sun.</p><p>I designed a more straightforward logo, capitalizing on the friendly, approachable nature of blue to deliver a dependable, kid-friendly feel and also to provide inherent lasting power to the logo itself (as blue vinyl does not fade as quickly in outdoor conditions).</p><p>Archery For Kids now has a low-cost, low-maintenance logo that is easier to reproduce and holds up well over time in the elements.</p>"
    },
    {
      name: "SeraLabs Logo",
      imgName: "seralabs-logo.jpg",
      altText: "Logo for SeraLabs, a bay-area staffing startup, SeraLabs.",
      description:
        "<p><b>Client:</b> SeraLabs.io is a bay-area startup in stealth-mode, developing an in-browser app that brings something new to the hiring process.</p><p>SeraLabs is just getting started and so its story must remain mostly under-wraps, but it will be entering a well-established industry and thus a strong sense of identity is imperative for this company to break into its professional network with a clear message about its unique solution to the hiring process.</p><p>I consulted with SeraLabs to design their brand identity, which included designing their logo, landing page,print collateral, and in-browser app (visual design and prototyping only; the app is being developed by SeraLabs).</p><p>SeraLabs has yet to pull the curtain back for public eyes, but I look forward to sharing the project in more detail and analyzing the success of the design in the future.</p>"
    },
    {
      name: "FairGround Creative Logo",
      imgName: "fairgroundcreative-logo.jpg",
      altText: "Logo for FairGround Creative, a Texas-based design company.",
      description:
        "<p><b>Client:</b> Fairground Creative seeks out freelance graphic-artists to pair with professionals who need services for specific projects. They needed a logo that suggested their role as an innovative and creative company without misbranding themselves as only a design company.</p><p>Playing off of the name of the company, I designed a logo with a Ferris wheel as inspiration. The Ferris Wheel was suggested by spokes, radiating out from a pencil. Unrestrained by the circular boundary, the image suggests movement, ideas, and the networking nature of the company, and the pencil refers to a base of creativity that powers the wheel.</p>"
    },

    {
      name: "Urban &Aacute;lez Logo",
      imgName: "urbanalez-logo.png",
      altText:
        "Logo for Urban|&Aacute;lez, an upscale custom furniture design firm.",
      description:
        "<p><b>Client:</b> Urban|&Aacute;lez is a luxury furniture and woodworking company which hand-crafts unique, high-end furniture and specializes in linen applications. When Urban|&Aacute;lez approached me, it was under a different name because the company was mid-acquisition and they were at risk of losing their vital clientele in the wake of new management and a new identity.</p><p>I consulted with the new owner, Mr. Gonz&aacute;lez (a fellow designer), to secure a strong message and purpose and understand the history of the company he had acquired and the nature of its clients to identify what value would keep them despite the uncertainties clients face from new management. It was the exclusive experience and relationship with their designer that these customers loved, and so we were in luck: Mr. Gonz&aacute;lez was known to many of them, and eager to provide these private collectors a one-on-one furniture design experience, personally tailored from start to finish.</p><p>And so I decided to make the logo personalized to Mr. Gonz&aacute;lez because the unique value of Urban|&Aacute;lez is the vision, passion, and attention of the man himself.  He was proud of his family name and careful to make sure that the '&aacute;' in 'Gonz&aacute;lez' would survive the generations with its accent in tact.  I braided the '&aacute' into the logo and utilized generous spacing and bold, intersecting lines and contrasts of weight to evoke a disciplined, architectural, sophisticated aesthetic, providing Urban|&Aacute;lez a logo that nailed the unique value of the company.</p"
    },

    {
      name: "Grace and Pax House Logo",
      imgName: "graceandpaxhouse-logo.png",
      altText:
        "Logo for Grace and Pax House, an assisted living home in Dripping Springs, Texas.",
      description:
        "<p><b>Client:</b>Grace And Pax House is an assisted living home in Dripping Springs, Texas.  They concentrate on establishing a traditional, comfortable family environment.</p><p>"
    },
    {
      name: "Curious Bird Design",
      imgName: "bird-design.jpg",
      altText: "A rhythmic design of a bird.",
      description: "<p></p>"
    }
  ]
};

const imageData = {
  [paintingItems._id]: paintingItems,
  [digitalItems._id]: digitalItems
};

export default imageData;



// WEBPACK FOOTER //
// ./src/data/imagedata.js